import { render } from "./SingleUserWithBadgeExample.vue?vue&type=template&id=5c9728ea&ts=true"
import script from "./SingleUserWithBadgeExample.vue?vue&type=script&lang=ts"
export * from "./SingleUserWithBadgeExample.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__